import { render, staticRenderFns } from "./RawSaveModal.vue?vue&type=template&id=708c6238&scoped=true"
import script from "./RawSaveModal.vue?vue&type=script&lang=js"
export * from "./RawSaveModal.vue?vue&type=script&lang=js"
import style0 from "./RawSaveModal.vue?vue&type=style&index=0&id=708c6238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c6238",
  null
  
)

export default component.exports